import { MEMBERS, MEMBERS_AREA_V2, NOTIFICATIONS as NOTIFICATIONS_APP_DEF_ID, WIX_BLOG, WIX_BOOKINGS, WIX_EVENTS, WIX_FORUM, WIX_STORES, } from '@wix/app-definition-ids';
import { WidgetId } from './widgets';
export const ABOUT = {
    appDefinitionId: '14dbef06-cc42-5583-32a7-3abd44da4908',
    pageId: 'about',
    widgetId: WidgetId.About,
};
export const MY_ACCOUNT = {
    appDefinitionId: '14cffd81-5215-0a7f-22f8-074b0e2401fb',
    pageId: 'member_info',
    widgetId: WidgetId.MyAccount,
};
export const ALL_MEMBERS = {
    appDefinitionId: MEMBERS,
};
export const BLOG_LIKES = {
    appDefinitionId: WIX_BLOG,
    pageId: 'member-likes-page',
    widgetId: WidgetId.BlogLikes,
};
export const BLOG_COMMENTS = {
    appDefinitionId: WIX_BLOG,
    pageId: 'member-comments-page',
    widgetId: WidgetId.BlogComments,
};
export const BLOG_POSTS = {
    appDefinitionId: WIX_BLOG,
    pageId: 'member-posts-page',
    widgetId: WidgetId.BlogPosts,
};
export const CONTRIBUTOR_PROFILE = {
    appDefinitionId: 'f9694946-7e53-4ab4-9cc7-21d275993d39',
    pageId: 'contributor-profile',
    widgetId: WidgetId.ContributorProfile,
};
export const FILE_SHARE = {
    appDefinitionId: '1537b24e-29d1-6d8f-b8e1-d6860f2f70b9',
    pageId: 'wix_file_share_members_page',
    widgetId: WidgetId.FileShare,
};
export const FOLLOWERS = {
    appDefinitionId: '14ebe801-d78a-daa9-c9e5-0286a891e46f',
    pageId: 'following_followers',
    widgetId: WidgetId.FollowingFollowers,
};
export const FOLLOWERS_LIGHTBOX = {
    appDefinitionId: MEMBERS_AREA_V2,
    pageId: 'following_followers_lightbox',
    widgetId: WidgetId.FollowingFollowersLightbox,
};
export const FORUM_COMMENTS = {
    appDefinitionId: WIX_FORUM,
    pageId: 'member-comments-page',
    widgetId: WidgetId.ForumComments,
};
export const FORUM_POSTS = {
    appDefinitionId: WIX_FORUM,
    pageId: 'member-posts-page',
    widgetId: WidgetId.ForumPosts,
};
export const MY_ADDRESSES = {
    appDefinitionId: '1505b775-e885-eb1b-b665-1e485d9bf90e',
    pageId: 'my_addresses',
    widgetId: WidgetId.MyAddresses,
};
export const MY_BOOKINGS = {
    appDefinitionId: WIX_BOOKINGS,
    pageId: 'bookings_member_area',
    widgetId: WidgetId.MyBookings,
};
export const MY_DRAFTS = {
    appDefinitionId: WIX_BLOG,
    pageId: 'member-drafts-page',
    widgetId: WidgetId.BlogDrafts,
};
export const MY_POSTS = {
    appDefinitionId: WIX_BLOG,
    pageId: 'My Posts',
    widgetId: WidgetId.MyPosts,
};
export const MY_EVENTS = {
    appDefinitionId: WIX_EVENTS,
    pageId: 'events_members_page',
    widgetId: WidgetId.Events,
};
export const MY_ORDERS = {
    appDefinitionId: WIX_STORES,
    pageId: 'order_history',
    widgetId: WidgetId.MyOrders,
};
export const MY_WALLET = {
    appDefinitionId: '4aebd0cb-fbdb-4da7-b5d1-d05660a30172',
    pageId: 'my_wallet',
    widgetId: WidgetId.MyWallet,
};
export const MY_WISHLIST = {
    appDefinitionId: WIX_STORES,
    pageId: 'wishlist',
    widgetId: WidgetId.MyWishlist,
};
export const NOTIFICATIONS = {
    appDefinitionId: NOTIFICATIONS_APP_DEF_ID,
    pageId: 'notifications_app',
    widgetId: WidgetId.Notifications,
};
export const SETTINGS = {
    appDefinitionId: '14f25dc5-6af3-5420-9568-f9c5ed98c9b1',
    pageId: 'settings',
    widgetId: WidgetId.Settings,
};
export const SHARED_GALLERY = {
    appDefinitionId: '476dc2dd-e16e-43b0-a0aa-1a486c78fbe2',
    pageId: 'Gallery',
    widgetId: WidgetId.SharedGallery,
};
export const MY_SUBSCRIPTIONS = {
    appDefinitionId: '2bef2abe-7abe-43da-889c-53c1500a328c',
    pageId: 'My Subscriptions',
    widgetId: WidgetId.MySubscriptions,
};
export const MY_CHALLENGES = {
    appDefinitionId: '2936472a-a1ed-4ae5-9f71-614313a9f4e7',
    pageId: 'My Challenges',
    widgetId: WidgetId.MyChallenges,
};
export const MY_PROGRAMS = {
    appDefinitionId: '2936472a-a1ed-4ae5-9f71-614313a9f4e7',
    pageId: 'My Programs',
    widgetId: WidgetId.MyPrograms,
};
export const MY_REWARDS = {
    appDefinitionId: '16ed1ac6-01cb-4fb6-a59e-c215cce8fdf6',
    pageId: 'My Rewards',
    widgetId: WidgetId.MyRewards,
};
export const MEMBER_SETTINGS_PAGE = {
    appDefinitionId: 'b976560c-3122-4351-878f-453f337b7245',
    pageId: 'member_settings_page',
    widgetId: WidgetId.SettingsPage,
};
export const MEMBER_PAGE = {
    appDefinitionId: 'b976560c-3122-4351-878f-453f337b7245',
    pageId: 'member_page',
    widgetId: WidgetId.MemberPage,
};
export const GROUPS = {
    appDefinitionId: '148c2287-c669-d849-d153-463c7486a694',
    pageId: 'My Groups',
    widgetId: WidgetId.Groups,
};
export const TEST_VERTICAL_PUBLIC_WIDGET = {
    appDefinitionId: '567d5e7e-4224-4488-a24b-d1ee5f691e54',
    pageId: 'test-vertical-public-widget',
    widgetId: WidgetId.TestPublic,
};
export const TEST_VERTICAL_PRIVATE_WIDGET = {
    appDefinitionId: '567d5e7e-4224-4488-a24b-d1ee5f691e54',
    pageId: 'test-vertical-private-widget',
    widgetId: WidgetId.TestPrivate,
};
//# sourceMappingURL=index.js.map